module.exports = "- Easily add to list\n\n\\<CrewMember \n  name=\"Bender\"\n  avatar=\"/assets/crew/bender.png\" />\n\n- Update a status\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/11_composition/notes_4.md
// module id = 1531
// module chunks = 0